'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeLogout = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-logout--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M19.1633 11H42.8367C44.586 11 46 12.4204 46 14.1776V49H16V14.1776C16 12.4204 17.414 11 19.1633 11Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M33.2713 8.00141L16.7287 10.1427C14.469 10.436 14.0568 12.0492 14 12.8559V49L28.3966 51.369L33.2713 51.9996C34.3941 52.0143 36 51.6183 36 49.1544V10.8466C36 8.38273 34.3941 7.97208 33.2713 8.00141Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M28 30H32",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M46 49H52",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M8 49H14",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-logout",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M19.1633 11H42.8367C44.586 11 46 12.4204 46 14.1776V49H16V14.1776C16 12.4204 17.414 11 19.1633 11Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M33.2713 8.00141L16.7287 10.1427C14.469 10.436 14.0568 12.0492 14 12.8559V49L28.3966 51.369L33.2713 51.9996C34.3941 52.0143 36 51.6183 36 49.1544V10.8466C36 8.38273 34.3941 7.97208 33.2713 8.00141Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M28 30H32",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M46 49H52",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M8 49H14",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
const MediumLogout = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M12.1189 6.18182H29.336C30.6082 6.18182 31.6365 7.21486 31.6365 8.49284V33.8182H9.81836V8.49284C9.81836 7.21486 10.8467 6.18182 12.1189 6.18182Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22.3793 4.00103L10.3483 5.5583C8.70485 5.77162 8.40511 6.94491 8.36377 7.53155V33.8182L18.8341 35.5411L22.3793 35.9997C23.1958 36.0104 24.3638 35.7224 24.3638 33.9305V6.07028C24.3638 4.27835 23.1958 3.97969 22.3793 4.00103Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M18.5454 20H21.4545",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M31.6362 33.8182H35.9999",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M4 33.8182H8.36364",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            })
        ]
    });
};
const Logout = ({ size, disabled = false })=>{
    if (size === 'medium') {
        return jsxRuntime.jsx(MediumLogout, {});
    }
    return jsxRuntime.jsx(LargeLogout, {
        disabled: disabled
    });
};

module.exports = Logout;
